<template>
	<div class="default-panel default-bg orderDetails-sec">
		
		<normalBar title="订单详情" :path="path"></normalBar>
		<div class="grey-bg-sec pd40">
			<div class="order-header-sec">
				<div class="timer-sec">
					<ul class="order-timer-list">
						<li><span class="text-grey">下单时间</span><span>{{createdTime}}</span></li>
						<li><span class="text-grey">订单号</span><span>{{merchantId}}</span></li>
						<li v-if="payModesDesc"><span class="text-grey">付款方式</span><span>{{payModesDesc}}</span></li>
						<li><span class="text-grey">商品总计</span><span>¥{{totalGoodsAmount | filterPrice}}</span></li>
						<li v-if="freightAmount"><span class="text-grey">发票运费</span><span>¥{{freightAmount | filterPrice}}</span></li>
						<li v-if="couponAmount"><span class="text-grey">优惠券</span><span>¥{{couponAmount | filterPrice}}</span></li>
						<li><span class="text-grey">订单总计</span><span>¥{{totalOrderAmount | filterPrice}}</span></li>
						<li><span class="text-grey">订单备注</span><span>{{remarks || '无'}}</span></li>
					</ul>
				</div>
				<div class="price-sec">
					<div>
						<span class="text-red">
							<p><span class="label">{{ status == 1 ? '需付款': '实付款'}}</span> ¥{{  status == 1  ? receiveTotalAmount : payTotalAmount  | filterPrice}}</p>
							<!-- <p v-if="status == 11"><span class="label">货到应付</span> ¥{{receiveTotalAmount  | filterPrice}}</p> -->
						</span>
					</div>
					<span v-if="status == 1">
						<countDown
							:timer = 'payTime'
							:payNo = 'payNo'
							v-on:timerOut = 'timerOuts'
						></countDown>
					</span>
				</div>
			</div>
		</div>
		
		<div class="grey-bg-sec"  v-for="(item,index) in giftBoxVoList" :key="index">
			<div class="pro-sec">
				<div class="gift-header">礼盒{{index+1}} <span class="text-red">{{item.userOrderStatusDesc}}</span></div>
				<div class="gift-sec">
					<div class="address-sec">
						<div class="address-content">
							<p class="title">收货地址</p>
							<p class="big-size">{{item.recipientVo.name}}<span class="last">收</span>{{item.recipientVo.mobile | filterPhone}}</p>
							<p>{{item.recipientVo.provinceName}} {{item.recipientVo.cityName}}  {{item.recipientVo.regionName}} {{item.recipientVo.address}}</p>
						</div>
						<button type="button" class="default-btn" v-if="item.userOrderStatus !== 1" @click="checkExpressInfo(item.orderCode)">物流详情</button>
					</div>
					<div class="gift-body">
						<router-link :to="{ path: '/productdetail/'+order.goodsChannelId, query: { url: router }}" v-for="order in item.merchantOrderDetailGoodsVos" :key="index">
						<div class="media">
							<div class="media-left">
								<img :src="order.imgUrl" alt="" v-if="!!order.imgUrl">
								<img src="../../assets/images/default-pro-small.png" alt="" v-else>
							</div>
							<div class="media-content">
								<p class="m-title">
									<span>{{order.showGoodsName}}</span>
									<span class="m-small">X{{order.orderGoodsNum}}</span>
								</p>
								<span class="m-subTitle text-grey">{{order.skuProperty}}</span>
								<div class="m-operate">
									<div class="m-operate-cont">
										<span class="price text-red">¥{{order.salePrice | filterPrice}}</span>
										<span class="chocoBoard text-grey" v-if="order.chocoBoard">
											生日牌：{{order.chocoBoard ? order.chocoBoard : '无'}}
										</span>
									</div>
								</div>
							</div>
						</div>
						<div class="greetingCard text-grey" v-if="order.greetingCard">	
							<span class="first">祝福贺卡：</span><span class="second">{{order.greetingCard}}</span>
						</div>
						</router-link>
					</div>
				</div>
				<div class="order-details-foot">
					<div  class="details-info" v-if="item.deliveryType == 1 || item.deliveryType == 2">
						<p><span class="text-grey">{{item.deliveryTypeDesc}}</span><span>{{item.deliveryTime}}</span></p>
					</div>
					<div class="details-info" v-if="item.deliveryType==3">
						<p><span class="text-grey">快递寄送</span><span>下单后48小时内统一发货</span></p>
						<p><span class="text-grey">物流单号</span><span v-if="item.expressVo.expressName">{{item.expressVo.expressName}} {{item.expressVo.expressNumber}}</span><span v-else>暂无信息</span></p>
					</div>

					<button type="button" class="default-btn" v-if="item.userOrderStatus == 7 || item.userOrderStatus == 8" @click="checkReceive(item.orderCode)">确认收货</button>
					<button type="button" class="default-btn" 
						v-if="giftBoxVoList.length>1&&item.cancel == 1 && status != 1" 
						@click="orderCancel(item.orderCode)">取消订单</button>
					<button type="button" class="default-btn" v-if="item.userOrderStatus == 15 || item.userOrderStatus == 16" @click="checkRefundDetails(item.orderCode)">退款详情</button>
				</div>
			</div>
		</div>
			
		<div class="order-type-foot"  v-if="cancelStatus ==1  && status == 1 "  @click="orderMchCancel()">取消订单</div>
		<div class="order-type-foot" @click="orderCancel(giftBoxVoList[0].orderCode)"
			v-if="(giftBoxVoList.length == 1 && giftBoxVoList[0].cancel == 1 && status !== 1)">取消订单</div>
	</div>



</template>

<script>
	import normalBar from '@/components/common/navbar/normalBar'
	import countDown from '@/components/order/countdown'
	import { Toast } from '@/js/mint-ui';

	import api from '@/api/api'


	import { mapState , mapGetters } from 'vuex'

	export default {
	    destroyed () {
	      document.removeEventListener("visibilitychange",this.eventHandler,false);
	      this.$store.commit('SESTINIT')
	    },
		data(){
			return {
        		eventHandler: undefined,
			}
		},
		computed:{
			...mapGetters([
				'cancelStatus',
				'receiveTotalAmount',
				'couponAmount',
				'payTotalAmount',
				'createdTime',
				'status',
				'statusDesc',
				'totalOrderAmount',
				'merchantId',
				'payModesDesc',
				'payModesId',
				'payNo',
				'payTime',
				'remarks',
				'totalGoodsAmount',
				'freightAmount'

				]),
			...mapState({
				giftBoxVoList: state => state.orderDetails.giftBoxVoList
			}),
      		router(){
        		return this.$route.path;
      		},
			isBg(){
				return this.giftBoxVoList.length > 1 ? true : false;
			},
			tabStatus(){
				return this.$route.query.status ? this.$route.query.status : 0;
			},
      		path () {
			  	if (this.$route.query.url) {
			    	return this.$route.query.url
        		}
			  	return '/orderManager/' + this.tabStatus
      		}
		},
		components: {
			normalBar,
			countDown
		},
		mounted(){
			let self = this;
			this.getDetails();
			this.eventHandler = function(){
	        	// document.title = document.hidden ? "用户离开了" : "用户回来了";
		        if(!document.hidden){
		          	self.getDetails();
		        }
      		}
			document.addEventListener("visibilitychange", this.eventHandler);
		},
		methods: {
			getDetails(){
				let self = this;
				let mchId = self.$route.params.mchId;
				this.$store.dispatch('getOrderDetails',mchId)
			},
			orderCancel(orderId){
				let self = this;
				this.$router.push({
					path: '/orderCancel/'+orderId
				})
			},
			orderMchCancel(){
				let self = this;
				this.$router.push({
					path: '/orderCancel/'+self.merchantId,
					query: {
						isMchId: true	
					}
				})
			},
			checkReceive(orderCode){
				let self  = this;
				this.$store.dispatch('signOrder',orderCode).then(function(res){
					self.$router.push({
						path: '/orderManager/0'
					})
	        	})
			},
			checkRefundDetails(orderCode){
				this.$router.push({
					path: '/orderRefundDetails/'+orderCode
				})
			},
			timerOuts(){
				this.$store.commit('ORDERDETAILSCANCEL')
			},
			checkExpressInfo(id){
				this.$router.push({
						path: '/expressList/'+id
					})

			}
		}


	}


</script>

<style lang="scss">
@import '../../assets/css/mixin';


.grey-bg-sec.pd40 {
	padding-bottom: pxToRem(40px);
}

.orderDetails-sec {
	position: relative;
	.grey-bg-sec:last-of-type {
		padding-bottom: 0;
	}

	.order-header-sec {
		padding-left: pxToRem(50px);
		background-color: #fff;

	}

	.order-timer-list {
		padding: pxToRem(20px) 0;
		border-bottom: 1px solid #ccc;

		li {
			padding: pxToRem(10px) 0;

			.text-grey {
				display: inline-block;
				width: pxToRem(120px);
				color: #666666;
			}
		}
	}


	.price-sec {
		padding: pxToRem(25px) pxToRem(50px) pxToRem(25px) 0;
		display: flex;
		justify-content: space-between;
		> div{
			display: inline-flex;
			align-items: center;
		}
		
		.label {
			display: inline-block;
			width: pxToRem(100px);
		}
		
	}

	.pro-sec {
		
		background-color: #fff;

		.address-sec {
			padding-left: 0;
			padding-right: pxToRem(50px);
			border-bottom: none;
			.address-content {
				max-width: 100%;
			}
		}

		.gift-header {
			padding: pxToRem(36px)  pxToRem(50px)  pxToRem(36px) pxToRem(50px);
			display: flex;
			justify-content: space-between;
			color: #030303;
			border-bottom: 1px solid #D4B675;
		}

		.gift-sec {
			padding: 0 0 0 pxToRem(50px);
			background-color: #fff;


			.media{
				padding: pxToRem(34px) pxToRem(54px) pxToRem(20px) 0;
				border-top: 1px solid #eeeeee;

				.media-left {
					width: pxToRem(132px);
					height: pxToRem(132px);
				}
				.media-content {
					padding-top: 0;
				}

				.m-operate {
					padding-right: 0;
					line-height: 1;

					.text-red {
						line-height: 1;
					}
				}

				.m-small {
					font-size: pxToRem(20px);
					color: $defaultColor;
					position: absolute;
				    top: 0;
				    right: 0;
				}
			}
		}

		.order-details-foot {
			padding: pxToRem(36px) pxToRem(36px) pxToRem(36px) pxToRem(50px);
			display: flex;
			justify-content: space-between;
			align-items: center;
			// height:pxToRem(100px);
			border-top: 1px solid #eeeeee;
			color: #000;
			
			.details-info {
				p {
					padding: pxToRem(3px) 0;
				}
			}

			.text-grey{
				margin-right: pxToRem(20px);
				color: #666;
			}
		}
	}


	.order-type-foot {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		line-height: pxToRem(110px);
		text-align: center;
		background-color: #fff;
		font-size: pxToRem(28px);
	}
	.chocoBoard {
		color: #666;
	}
	.greetingCard {
		margin-bottom: pxToRem(40px);
		display: flex;
		color: #666;
		font-size: pxToRem(20px);
		.first {
			width: pxToRem(140px);
		}
		.second {
			flex: 1;
		}
	}

}



</style>


// WEBPACK FOOTER //
// orderDetails.vue?40c4656d